module.exports = __webpack_public_path__ + "sq18-786ac6b3.png";